import formatDecimal from "./formatDecimal";

export default function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-format/src/exponent.js
// module id = XaCk
// module chunks = 0